
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $c98c4916b93ef841$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"1yVM6\",\"UpgradeEditionButton.9fc0cda4.js\",\"fYFVU\",\"UpflowV2ExperimentErrorBoundary.95082ca7.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.0c83c9a1.js\",\"zSp86\",\"MainButtons.5340a03a.js\",\"ffEVr\",\"vendors~editor_icon.70cd94e7.js\",\"eeaKR\",\"credit-card.39a2b6fa.js\",\"6wr18\",\"vendors~editor_icon.d35f9155.js\"]"));


$parcel$global.rlb("1qlDN")
//# sourceMappingURL=UpgradeEditionButton.runtime.f22f2a93.js.map
